import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import store from "./store";
import Layouts from "./layouts";
import { THEME_CONFIG } from "./configs/AppConfig";
import "./lang";
import { fetchUserData } from "store/slices/userSlice";
import "./index.css";
 
function getRouterBasename(publicUrl) {
  if (!publicUrl) return "";
  try {
    // CRA allows PUBLIC_URL to be a full URL; React Router basename must be a path.
    const url = new URL(publicUrl, "http://placeholder");
    const path = url.pathname.replace(/\/+$/, "");
    return path === "/" ? "" : path;
  } catch {
    // If it's already a path like "/admin", normalize it.
    const path = String(publicUrl).replace(/\/+$/, "");
    return path === "/" ? "" : path;
  }
}

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
  useEffect(() => {
    // Get the authentication token from the store
    const auth = store.getState().auth;
    // Get the user data from the store
    const user = store.getState().user;

    // Check if there's a token and user data is not available
    if (auth.token && !user.userData) {
      // Dispatch the fetchUserData action using the store directly
      store.dispatch(fetchUserData(auth.token));
    }
  }, []);
  const basename = getRouterBasename(process.env.PUBLIC_URL);

  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter basename={basename}>
          <ThemeSwitcherProvider
            themeMap={themes}
            defaultTheme={THEME_CONFIG.currentTheme}
            insertionPoint="styles-insertion-point"
          >
            <Layouts />
          </ThemeSwitcherProvider>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
